import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative h-5px rounded-l-full rounded-r-full border-[1px] border-solid border-slateGray" }

interface Props {
  progress: number
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'AudioProgress',
  props: {
    progress: null
  },
  setup(__props: any) {

const props = __props as {
  progress: number
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "h-full bg-slateGray rounded-l-full rounded-r-full",
      style: _normalizeStyle({ width: props.progress * 100 + '%' })
    }, null, 4)
  ]))
}
}

})